import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../ApiTS/ServiceDatasTS";
import { useApi } from "../../../../../hooks/useApi";
import DotStatus from "../../../../DefaultStyles/DotStatus";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import { OptionType } from "../../../../Filters/DropDown";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import GetTempAccountBtn from "./GetTempAccountBtn";
import TempAccountHistoryFilter from "./TempAccountHistoryFilter";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../../Table/Pagination";
import { TotalCount } from "../../../../../pages/Users/UserInfo";
import { getThousandComma } from "../../../../../ApiTS/ApiCommonTS";

interface IAllot {
  Failreason: string;
  isFail: number;
  partyid: number;
  requestReason: number;
  requesttime: string;
  servid: number;
  servsubsid: number;
  tempId?: number;
  uid: number;
}

export default function TempAccountHistory() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [searchOption, setSearchOption] = useState<OptionType>({
    value: "",
    label: "선택",
  }); // 검색 타입
  const [searchValue, setSearchValue] = useState<string | undefined>(""); // 검색어
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    value: "",
    filterType: "",
  });
  const [viewData, setViewData] = useState({
    user: "",
    subsData: "",
    partyId: "",
  });

  const tableHead = [
    "Subscription",
    "PID",
    "UID",
    "발급 사유",
    "발급 상태",
    "발급 계정",
    "발급 실패 사유",
    "발급 요청 시각",
    "대여 만료일",
    "발급",
  ];

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url:
      `temp-account/allot?page=${page}&size=10` +
      (searchValue !== "" ? `&${searchOption?.value}=${searchValue}` : ``) +
      (filters?.filterType !== ""
        ? `&${filters?.filterType}=${filters?.value}`
        : ``) +
      (filters?.enddate !== ""
        ? `&startdate=${filters?.startdate}&enddate=${dayjs(filters?.enddate)
            ?.add(1, "day")
            ?.format("YYYY-MM-DD")}`
        : ``),
  });

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "임시 계정 발급 내역 조회에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <TempAccountHistoryFilter
        setSearchOption={setSearchOption}
        setSearchValue={setSearchValue}
        searchDisabled={searchOption?.value === ""}
        setFilters={setFilters}
      />

      <LineBox>
        <>
          <Table tableHeadData={tableHead}>
            <>
              {response?.data?.items?.map((a: IAllot) => {
                const subData = GetSubscriptionSetData(a?.servsubsid ?? 0);
                const servData = GetServiceSetData(subData?.SVC_ID ?? 0);

                const reqDate = a?.requesttime ?? undefined;
                const reqTime = Number(dayjs(reqDate)?.format("HH") ?? 0);

                const expdate =
                  reqTime < 18
                    ? `${dayjs(reqDate).format("YYYY-MM-DD")} 23:59:59`
                    : `${dayjs(reqDate)
                        ?.add(1, "d")
                        .format("YYYY-MM-DD")} 23:59:59`;

                return (
                  <TableBody>
                    <TableBodyItem>
                      {a.servsubsid}_{subData?.SUBS_NM_TEMP ?? ""}
                    </TableBodyItem>

                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/party/info/${a?.partyid}`)}
                    >
                      {a?.partyid}
                    </TableBodyItem>

                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/users/info/${a?.uid}`)}
                    >
                      {a?.uid}
                    </TableBodyItem>

                    <TableBodyItem>
                      {a?.requestReason === 1
                        ? "로그인 체크 실패"
                        : a?.requestReason === 2
                        ? "이용권 체크 실패"
                        : a?.requestReason === 3
                        ? "Admin"
                        : "-"}
                    </TableBodyItem>

                    <TableBodyItem>
                      <DotStatus
                        text={a?.isFail === 0 ? "성공" : "실패"}
                        color={a?.isFail === 0 ? "#00c7c7" : "#f42d16"}
                        size="sm"
                      />
                    </TableBodyItem>
                    <TableBodyItem>
                      {a?.tempId
                        ? `${servData?.SVC_NMKR_TEMP ?? ""}_${a?.tempId}`
                        : "-"}
                    </TableBodyItem>

                    <TableBodyItem>
                      {a?.isFail === 0
                        ? "-"
                        : a?.isFail === 20027005
                        ? "발급 가능 계정 없음"
                        : a?.isFail === 20027006
                        ? "발급 요청 횟수 초과"
                        : a?.isFail === 20027007
                        ? "발급 중복 요청"
                        : "-"}
                    </TableBodyItem>

                    <TableBodyItem>
                      {dayjs(a?.requesttime).format("YYYY-MM-DD HH:mm:ss")}
                    </TableBodyItem>

                    <TableBodyItem>{expdate ?? "-"}</TableBodyItem>

                    <TableBodyItem>
                      <GetTempAccountBtn
                        buttonDisabled={a?.isFail === 0}
                        clickEvent={() => {
                          setViewData({
                            user: `${a?.uid ?? 0}`,
                            subsData: `${a.servsubsid}_${
                              subData?.SUBS_NM_TEMP ?? ""
                            }`,
                            partyId: `${a?.partyid ?? 0}`,
                          });
                        }}
                        historyInfo={viewData}
                        subsId={a.servsubsid ?? 0}
                        refetch={() =>
                          fetchData({
                            method: "get",
                            url: `temp-account/allot?page=${page}&size=10`,
                          })
                        }
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
            </>
          </Table>

          <SpaceBetween>
            <Pagination
              totalPage={response?.status === 200 ? response.data.totalPage : 1}
              currentPage={page}
              pageClickEvent={(index) => setPage(index)}
            />

            <TotalCount>
              총{" "}
              {getThousandComma(
                response?.status === 200 ? +response?.data?.totalCount : 0
              )}
              개
            </TotalCount>
          </SpaceBetween>
        </>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
